module.exports = __webpack_public_path__ + "static/media/toilet.b3e3ec53.svg";